import React, { useState } from 'react';
import { Calendar, dateFnsLocalizer } from 'react-big-calendar';
import { format, startOfWeek, getDay, addMonths, subMonths } from 'date-fns';
import enCA from 'date-fns/locale/en-CA';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import './calendar-custom.css';

const locales = { 'en-CA': enCA };

const localizer = dateFnsLocalizer({
  format,
  parse: (value) => new Date(value),
  startOfWeek,
  getDay,
  locales,
});

const CalendarBookings = ({ bookings }) => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [view, setView] = useState('week');

  const events = bookings.map((b) => {
    try {
      const fecha = new Date(b.fecha);
      const start = new Date(fecha);
      const end = new Date(fecha);
      const [h1, m1] = b.hora_inicio.split(':').map(Number);
      const [h2, m2] = b.hora_fin.split(':').map(Number);
      start.setHours(h1, m1, 0);
      end.setHours(h2, m2, 0);

      return {
        id: b.id,
        title: `${b.nombre_cliente} (${b.hora_inicio}–${b.hora_fin})`,
        start,
        end,
      };
    } catch {
      return null;
    }
  }).filter(Boolean);

  const eventStyleGetter = () => ({
    style: {
      backgroundColor: 'rgb(var(--color-primary))',
      color: 'rgb(var(--color-text))',
      borderRadius: '0.5rem',
      padding: '4px 8px',
      fontWeight: '600',
      border: 'none',
      boxShadow: '0 4px 10px rgba(var(--color-shadow))',
    },
  });

  return (
    <div className="lg:flex lg:h-full lg:flex-col">
      <header className="flex items-center justify-between border-b border-primary px-6 py-4 lg:flex-none bg-hover-bg">
        <h1 className="text-base font-semibold leading-6 text-primary">
          <time dateTime={currentDate.toISOString()}>{format(currentDate, 'MMMM yyyy')}</time>
        </h1>
        <div className="flex items-center">
          <div className="relative flex items-center rounded-md bg-white shadow-sm md:items-stretch">
            <button
              type="button"
              className="flex h-9 w-12 items-center justify-center rounded-l-md border-y border-l border-primary pr-1 text-gray-400 hover:text-gray-500 focus:relative md:w-9 md:pr-0 md:hover:bg-hover-bg"
              onClick={() => setCurrentDate(subMonths(currentDate, 1))}
            >
              <span className="sr-only">Previous month</span>
              <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fillRule="evenodd" d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z" clipRule="evenodd" />
              </svg>
            </button>
            <button
              type="button"
              className="hidden border-y border-primary px-3.5 text-sm font-semibold text-primary hover:bg-hover-bg focus:relative md:block"
              onClick={() => setCurrentDate(new Date())}
            >
              Today
            </button>
            <span className="relative -mx-px h-5 w-px bg-primary md:hidden"></span>
            <button
              type="button"
              className="flex h-9 w-12 items-center justify-center rounded-r-md border-y border-r border-primary pl-1 text-gray-400 hover:text-gray-500 focus:relative md:w-9 md:pl-0 md:hover:bg-hover-bg"
              onClick={() => setCurrentDate(addMonths(currentDate, 1))}
            >
              <span className="sr-only">Next month</span>
              <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fillRule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clipRule="evenodd" />
              </svg>
            </button>
          </div>
        </div>
      </header>

      <div className="flex-auto bg-[rgb(var(--color-bg))] text-[rgb(var(--color-text))]">
        <Calendar
          localizer={localizer}
          events={events}
          defaultView={view}
          views={['day', 'week', 'month']}
          date={currentDate}
          onNavigate={(date) => setCurrentDate(date)}
          onView={(v) => setView(v)}
          step={30}
          timeslots={2}
          startAccessor="start"
          endAccessor="end"
          min={new Date(0, 0, 0, 10, 0)}
          max={new Date(0, 0, 0, 23, 0)}
          eventPropGetter={eventStyleGetter}
          style={{ height: '700px', padding: '1rem' }}
        />
      </div>
    </div>
  );
};

export default CalendarBookings;